var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gltf',{attrs:{"src":"/models/m72-law/scene.gltf","position":"0 -0.8 0","scale":0.002 * _vm.scale}})}
var staticRenderFns = []

export { render, staticRenderFns }